/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to unlink this login method?`)
};

const zh_hans1_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要解除此登录方式的绑定吗？`)
};

const zh_hant1_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您確定要解除綁定此登入方式嗎？`)
};

const fr_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment délier cette méthode de connexion ?`)
};

const de_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du diese Login-Methode wirklich trennen?`)
};

const ja_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このログイン方法の連携を解除してもよろしいですか？`)
};

const ko_alert_confirm_unlink = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 로그인 방법의 연결을 해제하시겠습니까?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const alert_confirm_unlink = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.alert_confirm_unlink(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("alert_confirm_unlink", locale)
	if (locale === "en") return en_alert_confirm_unlink(inputs)
	if (locale === "zh-Hans") return zh_hans1_alert_confirm_unlink(inputs)
	if (locale === "zh-Hant") return zh_hant1_alert_confirm_unlink(inputs)
	if (locale === "fr") return fr_alert_confirm_unlink(inputs)
	if (locale === "de") return de_alert_confirm_unlink(inputs)
	if (locale === "ja") return ja_alert_confirm_unlink(inputs)
	return ko_alert_confirm_unlink(inputs)
};